import classNames from 'classnames';
import { useRef, useEffect } from 'react';

export const DynamicInput = ({ value, onInput, className = ''}) => {
    const inputRef = useRef(null);
     // Автоматически подстраиваем ширину при изменении значения
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.style.width = '50px';
            inputRef.current.style.width = `${inputRef.current.scrollWidth + 10}px`;
        }
    }, [value]);

    return (
        <input
            ref={inputRef}
            className={classNames({[className]: !!className})}
            value={value}
            onInput={onInput}
        />
    );
};
